import { SETTINGS_APP_ID, workspaceRootPath } from './appsRegistry';

/** List route for security groups; must match `<Resource name="securityGroups" />` (camelCase). */
export const SETTINGS_SECURITY_GROUPS_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/securityGroups`;

/** List route for users (Settings app). */
export const SETTINGS_USERS_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/users`;

/** Developer tool: which columns appear in security group record rules. */
export const SETTINGS_RECORD_RULE_FIELD_SETTINGS_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/recordRuleFieldSettings`;

/** Approval Workflows configuration (resource list; editor lives at `/<resourceKey>`). */
export const SETTINGS_APPROVAL_WORKFLOWS_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/approval-workflows`;

/** Financial year settings (Settings app). */
export const SETTINGS_FINANCIAL_YEARS_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/glFiscalYears`;

/** Tenant app install/uninstall management (Settings app). */
export const SETTINGS_INSTALLED_APPS_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/installed-apps`;

/** Company setup (Settings app). */
export const SETTINGS_COMPANIES_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/companies`;

/** Document sequence configuration (Settings app). */
export const SETTINGS_DOCUMENT_SEQUENCES_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/documentSequences`;

/** Sales tax rates (Settings app; shown only for tenants with Accounting or FBR Smart installed). */
export const SETTINGS_TAXES_LIST_PATH = `${workspaceRootPath(SETTINGS_APP_ID)}/fbrSalesTaxRates`;
